import { render } from "./AccountVerificationDataTable.vue?vue&type=template&id=32920202&scoped=true"
import script from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"
export * from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"

import "./AccountVerificationDataTable.vue?vue&type=style&index=0&id=32920202&scoped=true&lang=css"
import "./AccountVerificationDataTable.vue?vue&type=style&index=1&id=32920202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32920202"]])

export default __exports__